<button type="button" (click)="toggleBonos()" [disabled]="isDisabled"
  class="transition-all duration-200 w-10 h-10 bg_color p-2 text_blue rounded-full hover:button_color_customize hover:text_black hover:template_color_customize relative">
  <span class="sr-only">View notifications</span>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
    class="icon icon-tabler icons-tabler-outline icon-tabler-gift">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
    <path d="M12 8l0 13" />
    <path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7" />
    <path d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5" />
  </svg>

  <!-- Bullet de alerta -->
  <span *ngIf="newNoti && !isDisabled" class="absolute top-0 right-0 h-2.5 w-2.5 bg_red rounded-full"></span>
</button>

<!-- Notification Dropdown TODO: HIDDEN-->

<!-- OLD IMPLEMENTATION -->
<!-- <a (click)="toggleBonos()" ngClass="{{ isDisabled ? 'disabled' : '' }}">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" width="24" height="24" stroke-width="2" style="--darkreader-inline-stroke: currentColor"
    data-darkreader-inline-stroke="">
    <path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"></path>
    <path d="M12 8l0 13"></path>
    <path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"></path>
    <path d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"></path>
  </svg>
  <div *ngIf="newNoti && !isDisabled" class="new_noti"></div>
</a> -->

<app-modal-bonus [show]="show" (toggle)="closeModal()"> </app-modal-bonus>